module.exports = __webpack_public_path__ + "static/media/22ESCWA18.ddfcff5e.jpg";